var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63761 2.50003L13.3627 0.840088L11.9377 6.62812L10.1601 4.92158L7.29258 7.90853C7.19523 8.00993 7.06075 8.06725 6.92018 8.06725C6.77961 8.06725 6.64513 8.00993 6.54778 7.90853L4.4423 5.71531L1.34566 8.94098C1.14821 9.14665 0.821425 9.15332 0.615755 8.95588C0.410085 8.75843 0.403416 8.43164 0.600859 8.22597L4.0699 4.61239C4.16724 4.51099 4.30173 4.45367 4.4423 4.45367C4.58286 4.45367 4.71735 4.51099 4.81469 4.61239L6.92018 6.80561L9.41525 4.20657L7.63761 2.50003Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.e15627926d86cca74dab1d8d596cb20a.svg";
export { ForwardRef as ReactComponent };